
import { DAOExpanderABI } from "../../abis/DAOExpander.abi";
import { Web3ContractProvider, Web3ProviderExtras } from "../web3.provider";

import {
  DAOExpanderContractEventType,
  DAOExpanderContractFunctions,
  // @ts-ignore
} from "./sw-contract-functions";

const Web3DAOExpanderProvider = async (
  addressOrName: string,
  extras?: Partial<Web3ProviderExtras<DAOExpanderContractEventType>>
) => {
  return Web3ContractProvider<DAOExpanderContractEventType, DAOExpanderContractFunctions>(
    addressOrName,
    DAOExpanderABI,
    extras as Web3ProviderExtras<DAOExpanderContractEventType>
  );
};

export { Web3DAOExpanderProvider, DAOExpanderContractEventType, DAOExpanderContractFunctions };
